<template>
<div>
  <div class="row flex-column flex-sm-row">
    <div class="col-12 col-sm-5 col-md-5 d-flex flex-column justify-content-center align-items-end">
      <div class="questionPic d-flex justify-content-center align-items-end">
        <img :src="content.rightAnswerImage" style="max-width: 100%">
      </div>
      <div class="questionName d-flex flex-column align-items-center" v-if="false">
        <h5>自由女神</h5>
        <p>State of liberty</p>
      </div>
    </div>
    <div class="col-12 col-sm-7 col-md-7 flex-column">
      <div class="row d-flex flex-column">
        <div class="col-sm-12 d-flex align-items-center align-items-sm-end" style="height: 40vh;">
          <div class="row">
            <div class="col-4 col-sm-4" v-for="(img, index) in content.itemImages" :key="index">
              <div class="d-flex justify-content-center flex-column">
                <div class="tick">
                  <img v-if="content.answer === fromCharCode(index)" src="../assets/images/icon_correct_answer.png">
                </div>
                <div class="option">
                  <img :src="img" width="100%" />
                </div>
                <h5 class="percent">{{ $parent.countActionAnswer(index) }} %</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 d-flex align-items-center align-items-sm-end justify-content-center justify-content-sm-start finishMission">
          <div class="ml-md-5">
            <a class="btn btn-pink" @click="$emit('next')">結束任務</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'MissionNext',

  props: {
    content: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    }
  },

  methods: {
    fromCharCode (index) {
      return String.fromCharCode(65 + index)
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn {
    padding: 10px 30px;
    border-radius: 5px;
    color: white;
    font-weight: bold;
  }

  .questionPic {
    max-width: 400px;
    display:block;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .questionName {
    background: #e6e6e6;
    margin: 16px auto 0 auto;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    padding: 15px 30px;
    h5 {
      color:black;
      text-align: center;
      margin: 0;
      font-weight: 800;
      font-family: 'Times New Roman', Times, serif, '微軟正黑體';
    }
    p {
      color:black;
      text-align: center;
      margin: 0;
      font-family: 'Times New Roman', Times, serif, '微軟正黑體';

    }
  }

  .tick {
    width: 60px;
    height: 60px;
    display:block;
    margin: auto;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    h5 {
      text-align: center;
    }
  }

  .option {
    max-width: 180px;
    display:block;
    margin: auto;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .percent {
    font-size: 2em !important;
  }

  @media screen and (max-width: 769px) {
    .tick {
      width: 50px;
      height: 50px;
      display:block;
      margin: auto;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      h5 {
        text-align: center;
      }
    }
    .option {
      max-width: 250px;
      display:block;
      margin: auto;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .percent {
      font-size: 1.8em !important;
    }
  }

  @media screen and (max-width: 568px) {
    .tick {
      width: 50px;
      height: 50px;
      display:block;
      margin: auto;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      h5 {
        text-align: center;
      }
    }
    .option {
      max-width: 200px;
      display:block;
      margin: auto;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .finishMission {
    height: 20vh;
  }
</style>
